'use strict';

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPlyr = require('react-plyr');

var _reactPlyr2 = _interopRequireDefault(_reactPlyr);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactUseragent = require('@quentin-sommer/react-useragent');

var _utils = require('./utils');

var _getVideoId2 = require('get-video-id');

var _getVideoId3 = _interopRequireDefault(_getVideoId2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // UI


var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      CtaArea = _ref.CtaArea,
      DesktopPlayer = _ref.DesktopPlayer,
      MobilePlayer = _ref.MobilePlayer,
      VideoPreview = _ref.VideoPreview;

  var Webinar = function (_React$Component) {
    _inherits(Webinar, _React$Component);

    function Webinar(props) {
      _classCallCheck(this, Webinar);

      var _this = _possibleConstructorReturn(this, (Webinar.__proto__ || Object.getPrototypeOf(Webinar)).call(this, props));

      _this.fetchVideoDetails = function () {
        var videoUrl = _this.props.videoUrl;

        var _getVideoId = (0, _getVideoId3['default'])(videoUrl),
            service = _getVideoId.service,
            id = _getVideoId.id;

        if (service === 'youtube') return _this.fetchYoutubeDetails(id);
        if (service === 'vimeo') return _this.fetchVimeoDetails(id);
      };

      _this.fetchYoutubeDetails = function (videoId) {
        return fetch('https://www.googleapis.com/youtube/v3/videos?id=' + videoId + '&key=' + process.env.YOUTUBE_API_KEY + '&part=player,snippet,contentDetails&maxWidth=' + window.innerWidth).then(function (res) {
          return res.json();
        }).then(function (data) {
          var thumbnail = (0, _utils.getThumbnail)((0, _get2['default'])(data, 'items[0]', {}));
          var duration = (0, _get2['default'])(data, 'items[0].contentDetails.duration');

          var durationInS = _moment2['default'].duration(duration).asSeconds();

          var width = (0, _get2['default'])(data, 'items[0].player.embedWidth', 1280);
          var height = (0, _get2['default'])(data, 'items[0].player.embedHeight', 720);
          var ratio = 100 / (width / height);

          _this.setState({
            videoDuration: durationInS,
            thumbnail: thumbnail,
            ratio: ratio
          });
        });
      };

      _this.fetchVimeoDetails = function (videoId) {
        return fetch('https://vimeo.com/api/oembed.json?url=https://vimeo.com/' + videoId).then(function (res) {
          return res.json();
        }).then(function (data) {
          var thumbnail = data.thumbnail_url;
          var duration = data.duration;

          var durationInS = _moment2['default'].duration(duration).asSeconds();

          var width = (0, _get2['default'])(data, 'width', 1280);
          var height = (0, _get2['default'])(data, 'height', 720);
          var ratio = 100 / (width / height);

          _this.setState({
            videoDuration: durationInS,
            thumbnail: thumbnail,
            ratio: ratio
          });
        });
      };

      _this.showCTA = function () {
        _this.setState({
          ctaVisible: true
        });
      };

      _this.handlePlay = function () {
        _this.setState({
          playing: true
        });

        if (_this.plyr.current) _this.plyr.current.play();
      };

      _this.handlePause = function () {
        _this.setState({
          playing: false
        });
      };

      _this.triggerPlay = function () {
        if (_this.plyr.current) _this.plyr.current.play();
      };

      _this.triggerPause = function () {
        if (_this.plyr.current) _this.plyr.current.pause();
      };

      _this.handleCtaClick = function () {
        var clickHandler = _this.props.clickHandler;
        if (clickHandler) clickHandler();

        _this.triggerPause();
      };

      _this.handleFullscreenChange = function (isFull) {
        if (!isFull) {
          _this.plyr.current.pause();
        }

        _this.setState({
          playing: isFull
        });
      };

      _this.handleTimeUpdate = function (time) {
        _this.throttledCheckCtaVisibility(time);
      };

      _this.checkCtaVisibility = function (time) {
        var durationTrigger = _this.props.durationTrigger;
        if (time >= durationTrigger) return _this.showCTA();
      };

      _this.renderPlyr = function () {
        var videoUrl = _this.props.videoUrl;
        return _react2['default'].createElement(_reactPlyr2['default'], {
          videoId: videoUrl,
          controls: ['play-large'],
          onPlay: _this.handlePlay,
          onPause: _this.handlePause,
          onTimeUpdate: _this.handleTimeUpdate,
          ref: _this.plyr,
          type: _this.state.service
        });
      };

      _this.renderDesktop = function () {
        return _react2['default'].createElement(DesktopPlayer, {
          playing: _this.state.playing,
          ctaVisible: _this.state.ctaVisible,
          buttonProps: _this.buttonProps,
          onFullscreenChange: _this.handleFullscreenChange,
          onCloseClick: _this.triggerPause,
          onCtaClick: _this.handleCtaClick
        }, _this.renderPlyr());
      };

      _this.renderMobile = function () {
        return _react2['default'].createElement(MobilePlayer, {
          ratio: _this.state.ratio,
          buttonProps: _this.buttonProps,
          playing: _this.state.playing,
          ctaVisible: _this.state.ctaVisible,
          onCloseClick: _this.triggerPause,
          onCtaClick: _this.handleCtaClick
        }, _this.renderPlyr());
      };

      _this.throttledCheckCtaVisibility = (0, _throttle2['default'])(_this.checkCtaVisibility, 1000);

      _this.renderPlayer = function (parser) {
        var result = parser.getResult();
        var deviceType = (0, _get2['default'])(result, 'device.type', 'desktop');

        if (deviceType === 'tablet' || deviceType === 'mobile') {
          return _this.renderMobile();
        }

        return _this.renderDesktop();
      };

      _this.plyr = _react2['default'].createRef();
      _this.state = {
        service: (0, _get2['default'])((0, _getVideoId3['default'])(props.videoUrl), 'service', 'youtube'),
        videoDuration: 0,
        passedTime: 0,
        ctaVisible: false,
        playing: false,
        thumbnail: '',
        ratio: 56.2 // 16:9

      };
      return _this;
    }

    _createClass(Webinar, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.fetchVideoDetails();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (prevProps.videoUrl !== this.props.videoUrl) {
          this.fetchVideoDetails();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            theme = _props.theme,
            messageText = _props.messageText,
            ctaVisible = _props.ctaVisible,
            noInteraction = _props.noInteraction;
        var wrapperClass = (0, _classnames2['default'])(theme.wrapper, _defineProperty({}, theme.noInteraction, noInteraction));
        return _react2['default'].createElement(_reactUseragent.UserAgentProvider, {
          ua: this.userAgent
        }, _react2['default'].createElement('div', {
          className: wrapperClass
        }, !this.state.playing && _react2['default'].createElement(VideoPreview, {
          src: this.state.thumbnail,
          onPlayClick: this.triggerPlay
        }), _react2['default'].createElement(_reactUseragent.UserAgent, {
          returnFullParser: true
        }, this.renderPlayer), _react2['default'].createElement(CtaArea, {
          buttonProps: this.buttonProps,
          messageText: messageText,
          ctaVisible: this.state.ctaVisible,
          ctaVisibleForced: ctaVisible,
          onCtaClick: this.handleCtaClick
        })));
      }
    }, {
      key: 'buttonProps',
      get: function get() {
        var _props2 = this.props,
            buttonText = _props2.buttonText,
            buttonColor = _props2.buttonColor,
            buttonTextColor = _props2.buttonTextColor,
            buttonLink = _props2.buttonLink;
        return {
          text: buttonText,
          bgColor: buttonColor,
          textColor: buttonTextColor,
          link: buttonLink
        };
      }
    }, {
      key: 'userAgent',
      get: function get() {
        if (typeof window !== 'undefined') {
          return window.navigator.userAgent;
        }
      }
    }]);

    return Webinar;
  }(_react2['default'].Component);

  Webinar.displayName = identifier;
  Webinar.propTypes = {
    clickHandler: _propTypes2['default'].func,
    videoUrl: _propTypes2['default'].string.isRequired,
    durationTrigger: _propTypes2['default'].number.isRequired,
    buttonText: _propTypes2['default'].string.isRequired,
    buttonColor: _propTypes2['default'].string,
    buttonTextColor: _propTypes2['default'].string,
    buttonLink: _propTypes2['default'].string,
    messageText: _propTypes2['default'].string.isRequired,
    ctaVisible: _propTypes2['default'].bool,
    noInteraction: _propTypes2['default'].bool,
    theme: _propTypes2['default'].object.isRequired
  };
  return Webinar;
};

exports['default'] = factory;